import { default as _91slug_93F2NlbT4PZFMeta } from "/home/forge/career.proxify.io/releases/20250506142319/pages/[slug].vue?macro=true";
import { default as _91slug_93h1luXpAEH4Meta } from "/home/forge/career.proxify.io/releases/20250506142319/pages/article/[slug].vue?macro=true";
import { default as cookie_45policyJ4CquM1BxKMeta } from "/home/forge/career.proxify.io/releases/20250506142319/pages/cookie-policy.vue?macro=true";
import { default as _91slug_93QnTog6fl2jMeta } from "/home/forge/career.proxify.io/releases/20250506142319/pages/events/[slug].vue?macro=true";
import { default as indexqdq1zXD47RMeta } from "/home/forge/career.proxify.io/releases/20250506142319/pages/events/index.vue?macro=true";
import { default as how_45it_45worksGkrfeeyX3LMeta } from "/home/forge/career.proxify.io/releases/20250506142319/pages/how-it-works.vue?macro=true";
import { default as indexZiMpmV76Z1Meta } from "/home/forge/career.proxify.io/releases/20250506142319/pages/index.vue?macro=true";
import { default as jobsiv0K5G5H9fMeta } from "/home/forge/career.proxify.io/releases/20250506142319/pages/jobs.vue?macro=true";
import { default as journalTmAHj4qf15Meta } from "/home/forge/career.proxify.io/releases/20250506142319/pages/journal.vue?macro=true";
import { default as privacynitPOnBoz8Meta } from "/home/forge/career.proxify.io/releases/20250506142319/pages/privacy.vue?macro=true";
import { default as _91slug_930BK6Vwhp1NMeta } from "/home/forge/career.proxify.io/releases/20250506142319/pages/stories/[slug].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug()",
    component: () => import("/home/forge/career.proxify.io/releases/20250506142319/pages/[slug].vue")
  },
  {
    name: "article-slug",
    path: "/article/:slug()",
    component: () => import("/home/forge/career.proxify.io/releases/20250506142319/pages/article/[slug].vue")
  },
  {
    name: "cookie-policy",
    path: "/cookie-policy",
    component: () => import("/home/forge/career.proxify.io/releases/20250506142319/pages/cookie-policy.vue")
  },
  {
    name: "events-slug",
    path: "/events/:slug()",
    component: () => import("/home/forge/career.proxify.io/releases/20250506142319/pages/events/[slug].vue")
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/home/forge/career.proxify.io/releases/20250506142319/pages/events/index.vue")
  },
  {
    name: "how-it-works",
    path: "/how-it-works",
    component: () => import("/home/forge/career.proxify.io/releases/20250506142319/pages/how-it-works.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/forge/career.proxify.io/releases/20250506142319/pages/index.vue")
  },
  {
    name: "jobs",
    path: "/jobs",
    component: () => import("/home/forge/career.proxify.io/releases/20250506142319/pages/jobs.vue")
  },
  {
    name: "journal",
    path: "/journal",
    component: () => import("/home/forge/career.proxify.io/releases/20250506142319/pages/journal.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/home/forge/career.proxify.io/releases/20250506142319/pages/privacy.vue")
  },
  {
    name: "stories-slug",
    path: "/stories/:slug()",
    component: () => import("/home/forge/career.proxify.io/releases/20250506142319/pages/stories/[slug].vue")
  }
]